/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import {axiosInstance} from '../axiosInstance'
const getAllApplicationUsers = param => {
    return axiosInstance.post(`/api/gcadmin/v1/organization-application-user/getAll`,param).then(res => res.data)
}
const createApplicationUser = (app) => {
    return axiosInstance.post(`/api/gcadmin/v1/organization-application-user/create`,app).then(res => res.data)
}
const editApplicationUser = (app) => {
    return axiosInstance.post(`/api/gcadmin/v1/organization-application-user/update`,app).then(res => res.data)
}
const getAppUserHistory = param => {
    return axiosInstance.post(`/api/gcadmin/v1/organization-application-user/get-history`,param).then(res => res.data)
}
const getAllOrgsAppsUsersByOrgID = param => {
    return axiosInstance.post(`/api/gcadmin/v1/organization-application-user/getAllByOrganizationAppicationID`,param).then(res => res.data)
}
export {
    getAllApplicationUsers,
    createApplicationUser,
    editApplicationUser,
    getAppUserHistory,
    getAllOrgsAppsUsersByOrgID
}
